import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { Organization } from '../interfaces/organization';

@Injectable({
  providedIn: 'root'
})
export class OrganizationApiService {

  private http = inject(HttpClient);
  private url = environment.apiUrl + 'organization/';

  constructor() { }

  getOrganization(): Observable<any[]> {
      return this.http.get<Organization[]>(this.url);
  }

  createOrganization(organization: Organization): Observable<any[]> {
      return this.http.post<any>(this.url, organization);
  }

  updateOrganization(id: string, organization: Organization): Observable<any[]> {
      return this.http.put<any>(this.url + id, organization);
  }
}
